__turbopack_context__.v({
  "bodyMargin": "privacy-module-scss-module__q3CnWW__bodyMargin",
  "container": "privacy-module-scss-module__q3CnWW__container",
  "content": "privacy-module-scss-module__q3CnWW__content",
  "headlineMargin": "privacy-module-scss-module__q3CnWW__headlineMargin",
  "navBarSpacer": "privacy-module-scss-module__q3CnWW__navBarSpacer",
});
